import React from "react";
import { useLocation } from "react-router-dom";
import { Alert, Box } from "@mui/material";
import { useDemo } from "../context/DemoContext";
import {
  getDemoMarketOperationsDisabledMessage,
  getDemoMarketDataDisabledMessage,
} from "../utils/demoAccess";

export default function DashboardAccessGate({ children }) {
  const location = useLocation();
  const { demoProfile, demoError } = useDemo();
  const requestedView = new URLSearchParams(location.search).get("view");
  const view = ["optimization", "market", "bid_schedule", "economics"].includes(requestedView) ? requestedView : "weather";
  if (!demoProfile && !demoError) return null;
  if (demoError) return <Box sx={{ p: 3 }}><Alert severity="error">Account permissions are unavailable. Please refresh.</Alert></Box>;
  const disabled = view === "optimization" || view === "bid_schedule"
    ? getDemoMarketOperationsDisabledMessage(demoProfile)
    : view === "market" || view === "weather" ? getDemoMarketDataDisabledMessage(demoProfile) : "";
  if (disabled) return <Box sx={{ p: 3 }}><Alert severity="info">{disabled}</Alert></Box>;
  return children;
}
